/** @jsx isolateComponent */
import { ReactNode } from 'react';

import { isolateComponent } from '@zapier/common-utils';

import { useStaticAssetPath } from '../StaticAssetProvider';

type StaticLinkProps = {
  /** Link href */
  href: string;
  /** The children of the component. */
  children: ReactNode;
};

const StaticLink = ({ children, href, ...props }: StaticLinkProps) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();
  return (
    <a {...props} href={buildStaticAssetUrl(href)}>
      {children}
    </a>
  );
};

export default StaticLink;
